import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TooltipHelper {
  text: React.ReactNode;
  toolTipClass?: string;
  altIcon?: string;
}

const TooltipHelper = (props: TooltipHelper) => {
  const { text, toolTipClass, altIcon } = props;
  return (
    <>
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="button-tooltip">{text}</Tooltip>}
      >
        <i
          style={{ color: "#2a4d87" }}
          className={
            (!altIcon
              ? "fas fa-info-circle h-6 ml-1 cursor-pointer "
              : "h-6 ml-1 cursor-pointer " + altIcon) +
            (toolTipClass ? toolTipClass : "")
          }
        ></i>
      </OverlayTrigger>
    </>
  );
};

export default TooltipHelper;
